import React from 'react';

import { EuiBeacon } from '../../../../src/components';

export default () => (
  <>
    <EuiBeacon />
  </>
);
